import {
  GET_ALL_REQUEST,
  GET_ALL_SUCCESS,
  GET_ALL_FAIL,
} from '../actions/actionTypes'

import { bucket_url } from '../constants/const'
import { listPhotos } from '../libs/helpers'
import { listVideos } from '../libs/helpers'

const initialState = {
  loading: false,
  originality: {},
  carousels: [],
  notices: [],
  highlighter: [],
  publications: [],
  publicationCategory: [],
  courseModule: [],
  courseModuleDrafts: [],
  blog: [],
  blogDrafts: [],
  branch: [],
  collegeCategory: [],
  college: [],
  videoAlbums: [],
  photoAlbums: [],
  photos: [],
  videos: [],
  webExam: [],
  webExamDrafts: [],
  districts: [],
  homeStatistics: {},
  exclusives: [],
  testimonials: [],
  highlightInfo: {},
  exclusiveInfo: {}
}

export const allReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_REQUEST:
      return {
        ...state,
        loading: true
      }

    case GET_ALL_SUCCESS:
      let blogcategories = action.payload.blog.map(item => item.category)
      blogcategories = blogcategories.flat()
      blogcategories = [...new Set(blogcategories)]

      let districts = action.payload.branch.map(item => item.district)
      districts = [...new Set(districts)]

      const sortedPublictions = [...action.payload.publications]
      sortedPublictions.sort((a, b) => a.publishedAt > b.publishedAt ? - 1 : Date.now(a.publishedAt > b.publishedAt))



      return {
        loading: false,
        all: action.payload,
        originality: action.payload.originality,
        homeStatistics: action.payload.successStat,
        carousels: action.payload.carousels,
        notices: action.payload.notices,
        highlighter: action.payload.highlighter,
        publications: sortedPublictions.filter(item => !item.isDeleted),
        publicationCategory: action.payload.publicationCategory,
        courseModule: action.payload.courseModule.filter(item => !item.isDeleted),
        courseModuleDrafts: action.payload.courseModuleDrafts,
        blog: action.payload.blog.filter(item => !item.deletedAt),
        blogDrafts: action.payload.blogDrafts,
        branch: action.payload.branch.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)),
        collegeCategory: action.payload.collegeCategory,
        college: action.payload.college,
        photoAlbums: action.payload.photoAlbums,
        videoAlbums: action.payload.videoAlbums,
        photos: listPhotos(action.payload.photoAlbums),
        videos: listVideos(action.payload.videoAlbums),
        blogCategories: blogcategories,
        webExam: action.payload.webExam.filter(item => !item.deletedAt),
        webExamDrafts: action.payload.webExamDrafts,
        districts: districts,
        exclusives: action.payload.exclusive,
        testimonials: action.payload.testimonial,
        highlightInfo: action.payload.highlightInfo,
        exclusiveInfo: action.payload.exclusiveInfo
      }

    case GET_ALL_FAIL:
      return {
        ...state,
        loading: false
      }
    default: return state
  }
}